import React from 'react';

const FilterCard = ({ children }) => {
  return (
    <div className="filters-card card">
      <div className="card-body">
        {children}
      </div>
    </div>
  );
};

export default FilterCard; 